export default "__VITE_ASSET__4IryAYTZ__"